import React from 'react';
import Moment from 'react-moment';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogTitle from '@material-ui/core/DialogTitle';
import no_img from '../../img/no_img.jpg'
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Fade from '@material-ui/core/Fade';
import axios from 'axios';
import Util from '../Util/Util';
import FlexView from 'react-flexview';
import '../Util/Client';


const styles = theme => ({
    leftColumn: {
        textAlign: 'left',
    },
    paper: {
        position: 'absolute',
        width: theme.spacing.unit * 50,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
    },
});

class List extends React.Component {

    constructor(props, context) {
        super(props, context)
        this.handleOpen = this.handleOpen.bind(this)
        this.state = {
            open: false,
            test: {},
            status_click_detail: "",
            status: this.props.result.status,
            status_loading: false,
        }
    }

    statusToTH(status) {
        switch (status) {
            case "report": return "รอดำเนินการ";
            case "inprogress": return "กำลังดำเนินการ";
            case "finish": return "เสร็จสิ้น";
            default: return "ไม่เกี่ยวข้อง";
        }
        //"irrelevant": return "ไม่เกี่ยวข้อง"
    }

    handleOpen = (s_status) => {
        // if (this.props.result.comment != '' && s_status == 'comment') {
        this.setState({ status_click_detail: s_status, open: true });
        // }
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    Logout = () => {
        localStorage.clear()
        this.props.history.push('/login')
    }


    handleChangesStatus = (id) => e => {
        let token = localStorage.getItem('token')

        if (!Util.isLogin(token)) {
            this.Logout()
        } else {
            this.setState({ status_loading: true }, () => {
                this.patchSatusData(e, id, token)
            })
        }
    }//End handleChangesStatus

    patchSatusData = (e, id, token) => {
        let jsonData = { 'status': e.target.value }
        let headers = { headers: { 'content-type': 'application/json'
            , 'Authorization': `Bearer ${token}` }}
        axios.patch( `/fondue/${id}/`, jsonData, headers)
            .then(res => {             
                this.setState({ status: e.target.value, status_loading: false })
            }).catch(error => {
                // console.log(url)
                this.setState({ status_loading: false })
                alert('ไม่สามารถติดต่อข้อมูลได้ !!')
            });
    }//End patchSatusData

    render() {
        const data = this.props.result;
        const maxlimit = 50;
        const befor_photo = data.photos[0].photo
        return (
            <TableRow key={data.id} hover>
                <TableCell>
                    <Moment format="DD/MM/YYYY">
                        {data.timestamp}
                    </Moment>
                </TableCell>
                <TableCell numeric >
                    <img src={data.photos[data.photos.length - 1].photo} height="50" width="50"
                        onClick={this.handleOpen.bind(null, 'photo_befor')} />
                </TableCell>
                <TableCell numeric >
                    {(data.photos.length > 1) ? (
                        (befor_photo != null) ? (
                            <img src={befor_photo} height="50" width="50"
                                onClick={this.handleOpen.bind(null, 'photo_after')} />
                        ) : (
                                <img src={no_img} height="50" width="50" />
                            )
                    ) : (
                            <img src={no_img} height="50" width="50" />
                        )}
                </TableCell>
                <TableCell numeric style={{ textAlign: 'center' }}>
                    {data.problem_type}
                </TableCell>
                <TableCell numeric style={styles.leftColumn} >
                    <div onClick={this.handleOpen.bind(null, 'comment')}>{data.comment}</div>
                </TableCell>
                <TableCell numeric onClick={this.handleOpen.bind(null, 'address')}>
                    {((data.address).length > maxlimit) ?
                        (((data.address).substring(0, maxlimit - 3)) + '...') :
                        data.address}
                </TableCell>

                {/* <TableCell numeric>{this.statusToTH(data.status)}</TableCell> */}
                <TableCell >
                    { this.state.status_loading ? (
                        <Fade
                            in={this.state.status_loading}
                            style={{transitionDelay: '800ms',}}>
                            <FlexView style={{ flex: 1 }} hAlignContent='center'>
                                <CircularProgress color="primary"  />
                            </FlexView>  
                        </Fade>
                    ) : (
                        <Select
                            value={this.state.status}
                            onChange={this.handleChangesStatus(data.id)}>
                            <MenuItem value={'report'}>รอดำเนินการ</MenuItem>
                            <MenuItem value={'inprogress'}>กำลังดำเนินการ</MenuItem>
                            <MenuItem value={'finish'}>เสร็จสิ้น</MenuItem>
                            <MenuItem value={'irrelevant'}>ไม่เกี่ยวข้อง</MenuItem>
                        </Select>
                    )}

                </TableCell>
                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">รายละเอียด</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {(this.state.status_click_detail === 'photo_befor') ? (
                                <img src={data.photos[data.photos.length - 1].photo} height="500" width="500" />
                            ) : (this.state.status_click_detail === 'photo_after') ? (
                                <img src={befor_photo} height="500" width="500" />
                            ) : (this.state.status_click_detail === 'comment') ? (
                                data.comment
                            ) : (data.address)
                            }
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            ปิด
                        </Button>
                    </DialogActions>
                </Dialog>
            </TableRow>
        );
    }
}

export default List;


// WEBPACK FOOTER //
// ./src/components/List/List.js